/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CancelVerification200,
  CancelVerificationRequest,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Cancel signup verification.
 *
 * A no-op: the local record stays ``pending`` so the user can restart
 * verification later via ``POST /auth/resend-verification``. The frontend
 * should redirect to the login page.
 * @summary Cancel Verification
 */
export const cancelVerification = (
    cancelVerificationRequest: CancelVerificationRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<CancelVerification200>(
      {url: `/auth/cancel-verification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelVerificationRequest, signal
    },
      options);
    }




export const getCancelVerificationMutationKey = () => ['cancelVerification'] as const;

export const getCancelVerificationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelVerification>>, TError,CancelVerificationMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelVerification>>, TError,CancelVerificationMutationVariables, TContext> => {

const mutationKey = getCancelVerificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelVerification>>, CancelVerificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  cancelVerification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelVerification>>>
    export type CancelVerificationMutationBody = CancelVerificationRequest
    export type CancelVerificationMutationError = HTTPValidationError
    export type CancelVerificationMutationVariables = {data: CancelVerificationRequest}

    /**
 * @summary Cancel Verification
 */
export const useCancelVerification = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelVerification>>, TError,CancelVerificationMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelVerification>>,
        TError,
        CancelVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getCancelVerificationMutationOptions(options));
    }
